







import Vue from "vue";
import Component from "vue-class-component";
@Component({
  name: "Home",
  components: {}
  // Toutes les options de composant sont autorisées ici.
})
export default class Home extends Vue {}
